import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
const DEFAULT_OPTIONS = {
    attributes: true,
    childList: true,
    subtree: true
};
function useDocumentMutation(onDocumentMutation, options = DEFAULT_OPTIONS) {
    const [observer, setObserver] = (0, __WEBPACK_EXTERNAL_MODULE_react__.useState)(null);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        setObserver(new MutationObserver(onDocumentMutation));
    }, [
        onDocumentMutation
    ]);
    (0, __WEBPACK_EXTERNAL_MODULE_react__.useEffect)(()=>{
        null == observer || observer.observe(document, options);
        return ()=>{
            null == observer || observer.disconnect();
        };
    }, [
        observer,
        options
    ]);
}
export { useDocumentMutation };
